import CommonImage from '@/components/CommonImage';

const StyleImage = ({ style }) => (
	<div className="card-top">
		<CommonImage src={style?.designDocuments?.[0]?.docUrl} isStatic={false} />
	</div>
);

const StyleDetails = ({ style }) => (
	<div className="card-content ml-12">
		{style?.isNotFound && <span className="status brown-2">Not found</span>}
		<p class="regular-12 weight-500 gray_dark_01 my-1">{style.referenceNumber}</p>
		{style?.sampleInventoryItemResponseList?.length > 0 && (
			<p className="regular-12 gray_dark_02 mt-1">
				{
					style?.sampleInventoryItemResponseList[0]?.sampleInventoryLocationResponse
						?.countryResponse?.code
				}
				:
				<span className="gray_dark_01">
					{' '}
					{style?.sampleInventoryItemResponseList?.[0]?.sampleId}{' '}
				</span>
			</p>
		)}

		<ul class="common-list-component mt-1">
			<li>
				{style.basePrice && <span class="mb-0 semibold-12">P:${style.basePrice.toFixed(2)}</span>}
			</li>
		</ul>
	</div>
);

const StyleRow = ({ style, onRemoveItem, onOpenDesignView }) => (
	<tr>
		<td>{style.sl}</td>
		<td className="scan-list-item-column" onClick={() => onOpenDesignView(style)}>
			{!style.isFound && (
				<div className="card-content ml-12">
					<span className="status brown-2">Style Not found</span>
					<p class="regular-12 weight-500 gray_dark_01 my-1">{style?.designNumber}</p>
					<p className="regular-12 gray_dark_02 mt-1">
						Sample ID:<span className="gray_dark_01"> {style?.sampleId} </span>
					</p>
				</div>
			)}
			{style.isFound && (
				<div className="single-design-card d-flex align-items-center">
					<StyleImage style={style} />
					<StyleDetails style={style} />
				</div>
			)}
		</td>
		<td className="action-column">
			<CommonImage
				src="/icons/trash.svg"
				className="cursor-pointer"
				onClick={() => onRemoveItem(style?.sampleInventoryItemResponseList?.[0]?.id, style?.id)}
			/>
		</td>
	</tr>
);

const ScannedStylesListView = ({ styles, onRemoveItem, removeAll, onOpenDesignView }) => {
	return (
		<table className="table w-100 no-hover with-border">
			<thead></thead>
			<tbody>
				<tr>
					<th className="regular-14 align-middle">SL</th>
					<th className="regular-14 align-middle">Scanned output</th>
					<th className="text-center action-column align-middle">
						{styles.length > 0 && (
							<CommonImage
								src="/icons/trash.svg"
								className="cursor-pointer"
								onClick={() => removeAll()}
							/>
						)}
					</th>
				</tr>
				{styles.map((style, index) => (
					<StyleRow
						key={`${style.id}_${index}`}
						style={style}
						onRemoveItem={onRemoveItem}
						onOpenDesignView={onOpenDesignView}
					/>
				))}
			</tbody>
		</table>
	);
};

export default ScannedStylesListView;
